import { readable } from 'svelte/store';
import jsonExerciseIDs from '../data/exerciseIDs.json';
const exerciseIDs = new Array();
for (const jsonExerciseID of jsonExerciseIDs) {
    exerciseIDs.push(jsonExerciseID);
}
const exerciseIDsStore = readable(exerciseIDs, set => {
    set(exerciseIDs);
});
export { exerciseIDsStore };
